<!--
 * @Description:关闭任务项弹框
 * @Author: ChenXueLin
 * @Date: 2021-11-20 15:22:04
 * @LastEditTime: 2022-07-01 09:21:49
 * @LastEditors: ChenXueLin
-->
<template>
  <el-dialog
    v-dialogDrag
    :title="dialogType == 1 ? '关闭任务项' : '关闭任务单'"
    :visible="closeTaskItemDialog"
    width="500px"
    :close-on-click-modal="false"
    :element-loading-background="loadingBackground"
    :before-close="handleClose"
    v-loading="dialogLoading"
    custom-class="createDispatchDialog"
  >
    <el-form
      :model="closeForm"
      :rules="abnormalFormRules"
      :inline="true"
      label-width="120px"
      ref="closeForm"
    >
      <el-form-item
        :label="dialogType == 1 ? '关闭任务项原因' : '关闭任务单原因'"
        prop="closeReason"
      >
        <e6-vr-select
          v-model="closeForm.closeReason"
          :data="reasonList"
          :props="{
            id: 'codeValue',
            label: 'codeName'
          }"
          :placeholder="dialogType == 1 ? '关闭任务项原因' : '关闭任务单原因'"
          :title="dialogType == 1 ? '关闭任务项原因' : '关闭任务单原因'"
          clearable
        ></e6-vr-select>
      </el-form-item>
      <el-form-item
        :label="dialogType == 1 ? '关闭任务项备注' : '关闭任务单备注'"
        prop="closeRemark"
      >
        <el-input
          :placeholder="dialogType == 1 ? '关闭任务项备注' : '关闭任务单备注'"
          v-model="closeForm.closeRemark"
          maxlength="200"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit"> 确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { printError } from "@/utils/util";
import { findDownList, batchCloseItem, closeTask } from "@/api";
import base from "@/mixins/base";
export default {
  name: "closeTaskItemDialog",
  components: {},
  data() {
    return {
      closeForm: {
        closeReason: "",
        closeRemark: ""
      },
      reasonList: [], //异常完成原因下拉框
      dialogLoading: false,
      abnormalFormRules: {
        closeReason: [
          {
            required: true,
            message: "请选择关闭原因",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  props: ["closeTaskItemDialog", "itemIdList", "dialogType", "taskIdList"],
  mixins: [base],
  computed: {},
  watch: {},
  methods: {
    async initData() {
      try {
        let promiseList = [findDownList(["closeItemReason"])];
        let [res] = await Promise.all(promiseList);
        this.reasonList = this.getFreezeResponse(res, {
          path: "data.closeItemReason"
        });
      } catch (error) {
        printError(error);
      }
    },
    /*********关闭任务项**************/
    //关闭任务项请求
    async batchCloseItemReq() {
      try {
        this.dialogLoading = true;
        let res = await batchCloseItem({
          itemIdList: this.itemIdList,
          ...this.closeForm
        });
        if (res.code == "OK") {
          this.$message.success("关闭成功");
          this.handleClose();
          this.$emit("refresh");
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    //关闭工单请求
    async closeTaskReq() {
      try {
        this.dialogLoading = true;
        let res = await closeTask({
          taskIdList: this.taskIdList,
          ...this.closeForm
        });
        if (res.code == "OK") {
          this.$message.success("关闭成功");
          this.handleClose();
          this.$emit("refresh");
        }
      } catch (error) {
        printError(error);
      } finally {
        this.dialogLoading = false;
      }
    },
    handleClose() {
      this.closeForm = {
        closeReason: "",
        closeRemark: ""
      };
      this.$refs.closeForm.resetFields();
      this.$emit("handleClose", "closeTaskItemDialog");
    },
    handleSubmit() {
      this.$refs.closeForm.validate(valid => {
        if (valid) {
          if (this.dialogType == 1) {
            this.batchCloseItemReq();
          } else {
            this.closeTaskReq();
          }
        }
      });
    }
  },
  created() {
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
/deep/.createDispatchDialog {
  .el-dialog__body {
    padding: 10px;
  }

  .el-input {
    width: 300px;
  }
  .til {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
    margin-bottom: 15px;
    margin-left: 10px;
  }
}
</style>
